export function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length >= 2) return ((parts[0]?.[0] ?? '') + (parts[parts.length - 1]?.[0] ?? '')).toUpperCase()
  return (parts[0]?.[0] ?? '?').toUpperCase()
}

/** Derive an email local part from a user's first name (e.g. "Daniel" → "daniels-assistant"). */
export function userNameToEmail(name: string): string {
  const normalized = name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '')
  if (!normalized) return ''
  const possessive = normalized.endsWith('s') ? normalized : `${normalized}s`
  return `${possessive}-assistant`
}

/** Derive an email local part from an assistant name (e.g. "Daniel's Assistant" → "daniels.assistant"). */
export function assistantNameToEmail(name: string): string {
  return name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, '')
    .trim()
    .replace(/\s+/g, '.')
}

/** Generate personalized assistant name presets from a user's first name. */
export function personalizedPresets(firstName: string, language: string): { id: string; name: string }[] {
  const name = firstName.trim()
  if (!name) return []
  if (language === 'sv') {
    const possessive = name.endsWith('s') ? name : `${name}s`
    return [
      { id: '_personal_assistant', name: `${possessive} Assistent` },
      { id: '_personal_bot', name: `${possessive} Bot` },
    ]
  }
  const possessive = name.endsWith('s') ? `${name}'` : `${name}'s`
  return [
    { id: '_personal_assistant', name: `${possessive} Assistant` },
    { id: '_personal_bot', name: `${possessive} Bot` },
  ]
}
